module.exports = __webpack_public_path__ + "static/img/n22.c8b73ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n22.png
// module id = 2jY/
// module chunks = 3